"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerContextProvider = exports.LoggerContext = void 0;
const tslib_1 = require("tslib");
const client_utils_1 = require("@sensenet/client-utils");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
/**
 * Context for a Logger instance
 */
exports.LoggerContext = react_1.default.createContext(new client_utils_1.LoggerCollection());
exports.LoggerContext.displayName = 'LoggerContext';
/**
 * Wrapper for the LoggerContext component.
 * Returns the current injector's default logger. Has to be wrapped with **InjectorContext**
 */
const LoggerContextProvider = ({ children }) => {
    const injector = hooks_1.useInjector();
    return react_1.default.createElement(exports.LoggerContext.Provider, { value: injector.logger }, children);
};
exports.LoggerContextProvider = LoggerContextProvider;
//# sourceMappingURL=logger.js.map